import { ChartRecommendation, ColumnInfo } from './dataAnalyzer';
import { EvidenceInsightsEngine } from '../domain/analytics/evidenceInsightsEngine';
import { Citation, EvidencePoint } from '../domain/analytics/types';

export interface Insight {
  id: string;
  type: 'key_finding' | 'trend' | 'outlier' | 'correlation' | 'distribution' | 'root_cause';
  title: string;
  description: string;
  severity: 'low' | 'medium' | 'high';
  confidence: number;
  value?: string | number;
  impact?: string;
  recommendation?: string;
  method?: string;
  evidence?: EvidencePoint[];
  assumptions?: string[];
  limitations?: string[];
  citations?: Citation[];
}

const mapCategoryToType = (category: string): Insight['type'] => {
  switch (category) {
    case 'trend':
      return 'trend';
    case 'outlier':
      return 'outlier';
    case 'correlation':
      return 'correlation';
    case 'distribution':
      return 'distribution';
    default:
      return 'key_finding';
  }
};

export class InsightsAnalyzer {
  private engine: EvidenceInsightsEngine;

  constructor(data: any[], columnInfo: Map<string, ColumnInfo>, headers?: string[]) {
    this.engine = new EvidenceInsightsEngine(
      data,
      headers ?? Array.from(columnInfo.keys()),
      columnInfo
    );
  }

  generateInsights(recommendation: ChartRecommendation): Insight[] {
    return this.engine.generateInsights(recommendation).map((insight) => ({
      id: insight.id,
      type: mapCategoryToType(insight.category),
      title: insight.title,
      description: insight.finding,
      severity: insight.confidence >= 85 ? 'high' : insight.confidence >= 75 ? 'medium' : 'low',
      confidence: insight.confidence,
      value: insight.evidence[0]?.value,
      impact: insight.evidence.map((entry) => `${entry.metric}: ${entry.value}`).join(' • '),
      recommendation: insight.recommendation,
      method: insight.method,
      evidence: insight.evidence,
      assumptions: insight.assumptions,
      limitations: insight.limitations,
      citations: insight.citations
    }));
  }

  getProfile() {
    return this.engine.getProfile();
  }
}
